
import React from 'react';
import { FormFieldType } from '@/types/form';
import DevelopmentSection from './DevelopmentSection';
import StandardFormSection from './StandardFormSection';

interface FormContentRendererProps {
  isPage3: boolean;
  currentPageConfig: {
    elements: FormFieldType[];
    page: number;
  };
  elementGroups: {
    topicElements: FormFieldType[];
    knowledgeElements: FormFieldType[];
    skillsElements: FormFieldType[];
    attitudeElements: FormFieldType[];
    otherElements: FormFieldType[];
  } | null;
  documentUrls?: string[];
}

const FormContentRenderer: React.FC<FormContentRendererProps> = ({ 
  isPage3, 
  currentPageConfig, 
  elementGroups,
  documentUrls = []
}) => {
  if (isPage3 && elementGroups) {
    return <DevelopmentSection 
      elementGroups={elementGroups}
      documentUrls={documentUrls}
    />;
  }
  
  return <StandardFormSection 
    elements={currentPageConfig.elements} 
    documentUrls={documentUrls}
  />;
};

export default FormContentRenderer;
